import { render, staticRenderFns } from "./DigitalDepositModal.vue?vue&type=template&id=30f24b0f&scoped=true"
import script from "./DigitalDepositModal.vue?vue&type=script&lang=ts"
export * from "./DigitalDepositModal.vue?vue&type=script&lang=ts"
import style0 from "./DigitalDepositModal.vue?vue&type=style&index=0&id=30f24b0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f24b0f",
  null
  
)

export default component.exports